export default __webpack_public_path__ + "static/media/TT.c917b661.svg";